import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IrbCommonModule} from '@irb-common/irb-common.module';
import {IrbCreateRebalanceComponent} from './irb-create-rebalance.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    IrbCommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [IrbCreateRebalanceComponent]
})
export class IrbCreateRebalanceModule { }
